import { useRef } from 'react'

const TooltipBubble = ({
  children,
  text,
  disabled,
  hasCheck,
  info,
  fullWidth,
  position,
  width,
                         isCentered,
  whiteSpace
}) => {
  const container = useRef(null)
  let classContainer = whiteSpace + ' '
  let classTriangle = ''
  if (position.includes('center')) {
    classContainer += 'right-1/2 translate-x-1/2'
    classTriangle += 'right-1/2 translate-x-1/2'
  } else if (position.includes('left')) {
    classContainer += '-right-16'
    classTriangle += 'right-16'
  } else if (position.includes('right')) {
    classContainer += '-left-16'
    classTriangle += 'left-16'
  }
  if (position.includes('top')) {
    classContainer += ' bottom-[100%] mb-12'
    classTriangle += ' transform rotate-180 top-[100%]'
  } else if (position.includes('bottom')) {
    classContainer += ' mt-12'
    classTriangle += ' bottom-[100%]'
  }
  return (
    <div ref={container} className='relative'>
      <div className='peer'>{children}</div>
      {!disabled ? (
        <div
          style={width ? { width } : {}}
          className={
            'absolute bg-greyLight1 text-white text-xs rounded-8 px-12 py-8 pointer-events-none transition-opacity duration-200 peer-hover:opacity-100 opacity-0 ' +
            classContainer +
            (fullWidth ? ' w-full' : '')
          }
        >
          <div
            className={'w-0 h-0 border-[6px] absolute ' + classTriangle}
            style={{
              borderColor: 'transparent transparent #444B55 transparent',
            }}
          />
          <div className={"flex items-center space-x-8 " + (isCentered ? 'justify-center' : '')}>
            {hasCheck ? <i className='icon-check' /> : null}
            <span className='block text-xs font-medium'>{text}</span>
          </div>
          {info ? (
            <span className='block text-xs whitespace-normal text-greyLight6 mt-4'>
            {info}
          </span>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
TooltipBubble.defaultProps = {
  fullWidth: true,
  position: 'center bottom',
  width: null,
  isCentered: true,
  whiteSpace: 'whitespace-nowrap'
}
export default TooltipBubble
